import React, { useState, useContext } from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Select from 'react-select'
import Offcanvas from 'react-bootstrap/Offcanvas'

import AppConfigContext from '../../../app_layout/app_config_context'
import { ApiHelper } from '../../../../helpers/apihelper'
import showToastNotification from '../../../widgets/toastify'
import * as Constants from '../../../../helpers/constants'

import { PAYMENT_GATEWAY_OPTIONS } from '../../helpers/constants'
import { RENEWAL_UNITS } from '../../../../helpers/constants'

const SubscriptionPage = ({ user, product, onSuccess }) => {
  const { client } = useContext(AppConfigContext)
  const initialState = {
    showSubscriptionPage: false,
    quantity: 1,
    selectedPaymentGateway: null,
    isProcessingSubscription: false
  }
  const [subscriptionPageState, setSubscriptionPageState] = useState(initialState)
  if (!user || !product) return null

  const currency = product.price?.currency || ''
  const unitPrice = product.price?.actual_price || 0
  const total = unitPrice * subscriptionPageState.quantity
  const renewal = product?.renewal

  const renewalUnit = Object.values(RENEWAL_UNITS).find((unit) =>
    unit.patterns.some(
      (pattern) =>
        pattern.unit === renewal?.unit &&
        pattern.count === renewal?.count
    )
  )
  const billingLabel = renewalUnit
    ? `${renewalUnit.name} — ${currency} ${unitPrice}/${renewalUnit.short_name}`
    : `${currency} ${unitPrice}`
  const handleConfirm = () => {

    setSubscriptionPageState(prev => ({
      ...prev,
      isProcessingSubscription: true
    }))
    const body = {
      co_user_id: user.user_id || user._id,
      product_id: product._id,
      quantity: Number(subscriptionPageState.quantity),
      gateway: subscriptionPageState.selectedPaymentGateway?.value,
      description: `Subscription for ${product.display_name}`,
      amount: Number(total)
    }
    ApiHelper(client, 'BUY_SUBSCRIPTION')
      .API(client, body)
      .then(res => {
        if (res?.status === Constants.CO_API.SUCCESS) {
          showToastNotification({
            message: 'Subscription successful',
            isSuccess: true
          })
          setSubscriptionPageState(prev => ({
            ...prev,
            showSubscriptionPage: false
          }))
          onSuccess?.(user.user_id || user._id)
        } else {
          showToastNotification({
            message: res?.message || 'Subscription failed',
            isSuccess: false
          })
        }
      }) 
      .catch((err) => {
        console.error(err)
        const message =
        err?.response?.data?.message ||
        err?.message ||
        'Something went wrong'
        showToastNotification({
          message,
          isSuccess: false
        })
      })
      .finally(() =>
        setSubscriptionPageState(prev => ({
          ...prev,
          isProcessingSubscription: false
        }))
      )
  }
  return (
    <>
      <Button
        size="sm"
        variant="outline-success"
        onClick={() =>
          setSubscriptionPageState(prev => ({
            ...prev,
            showSubscriptionPage: true
          }))
        }
      >
        Subscribe
      </Button>
      <Offcanvas
        show={subscriptionPageState.showSubscriptionPage}
        onHide={() =>
          setSubscriptionPageState(prev => ({
            ...prev,
            showSubscriptionPage: false
          }))
        }
        placement="end"
      >

        <Offcanvas.Body>
          <div className="subscription-container">
            <div className="subscription-header">
              <div>
                <Offcanvas.Header closeButton>
                  <div className="subscription-title">
                    Subscribe to {product.display_name}
                  </div>
                </Offcanvas.Header>
                <div className="subscription-subtitle">
                  Subscribing <strong>{user.name}</strong> ({user.email})
                </div>
              </div>
            </div>
            <div className="mb-4">
              <div className="fw-semibold mb-2">
                Billing Cycle
              </div>
              <div className="border rounded p-2 text-center bg-light">
                {billingLabel}
              </div>
            </div>
            <div className="mb-4">
              <div className="fw-semibold mb-2">
                Quantity
              </div>
              <Form.Control
                className="subscription-quantity-input"
                type="number"
                min={1}
                step={1}
                value={subscriptionPageState.quantity}
                onChange={(e) => {
                  const value = Number(e.target.value)
                  if (value >= 1) {
                    setSubscriptionPageState(prev => ({
                      ...prev,
                      quantity: value
                    }))
                  }
                }}
              />
            </div>
            <div className="mb-4">
              <div className="fw-semibold mb-2">
                Payment Gateway
              </div>
              <Select
                options={PAYMENT_GATEWAY_OPTIONS}
                placeholder="Select Payment Gateway"
                value={subscriptionPageState.selectedPaymentGateway}
                onChange={(selected) =>
                  setSubscriptionPageState(prev => ({
                    ...prev,
                    selectedPaymentGateway: selected
                  }))
                }
              />
            </div>
            <hr className="my-4" />
            <div className="fw-semibold mb-3">
              Order Summary
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span>{product.display_name} × {subscriptionPageState.quantity}</span>
              <span>{currency} {total.toFixed(2)}</span>
            </div>
            <hr className="my-3" />
            <div className="d-flex justify-content-between fw-semibold fs-6 mb-4">
              <span>Total</span>
              <span>{currency} {total.toFixed(2)}</span>
            </div>
            <Button
              variant="outline-primary"
              className="w-100"
              size="md"
              disabled={
                !subscriptionPageState.selectedPaymentGateway ||
                subscriptionPageState.isProcessingSubscription
              }
              onClick={handleConfirm}
            >
              {subscriptionPageState.isProcessingSubscription
                ? 'Processing...'
                : `Confirm & Pay ${currency} ${total.toFixed(2)}`}
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  )
}

export default SubscriptionPage